import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";
import { loanManagementUrl } from "../../config";
import DynamicTableForJson from "../../data/DynamicTable/dynamicTableForJson";

const base_url = loanManagementUrl.uri;

const ROLoanAppraisal = () => {
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const userId = parseInt(decodedToken.Id);
  const roleGroupId = parseInt(decodedToken.RoleGroupId);

  // const [isCompany, setIsCompany] = useState("0");
  // const [isRegion, setIsRegion] = useState("0");
  // const [isBranch, setIsBranch] = useState("0");
  // const [isFieldOfficer, setIsFieldOfficer] = useState("0");


  // const rightId = localStorage.getItem("RightIdFromSidebar");

  // // Use useEffect to update state properly
  // useEffect(() => {
  //   if (rightId === "23") {
  //     setIsCompany("1");
  //   } else if (rightId === "22") {
  //     setIsRegion("1");
  //   } else if (rightId === "21") {
  //     setIsBranch("1");
  //   } else if (rightId === "20") {
  //     setIsFieldOfficer("1");
  //   }
  // }, [rightId]); // Runs only when rightId changes

  const columns = [
    { field: "Id", headerName: "ID", flex: 1 },
    { field: "CustomerId", headerName: "Customer ID" ,flex:1 },
    { field: "CustomerPhone", headerName: "Customer Phone" ,flex:1 },
    { field: "FirstName", headerName: "First Name", flex: 1 },
    { field: "OtherNames", headerName: "Other Names", flex: 2},
    { field: "ApplicationDate", headerName: "Booked Date", flex: 1.5 },
    { field: "AmountToDisburse", headerName: "Amount to Disburse",flex: 1 },
    { field: "InterestAmount", headerName: "Interest Amount" ,flex: 1},
    { field: "LoanAmount", headerName: "Loan Amount", flex: 1 },
    { field: "ServicedLoans", headerName: "Serviced Loans", flex: 1 },
    // { field: "LoanBalance", headerName: "Loan Balance", flex: 1 },
    { field: "InstallmentAmount", headerName: "Installment Amount" ,flex: 1.2},
    { field: "Name", headerName: "Branch" ,flex: 1},

  ];

  const actions = {
    entity: localStorage.getItem("SelectedRight"),
    edit: {
      key: "EDIT",
      button_name: "Edit",
      Show_Button: false,
      permission: "EditPermission",
    },
    add: {
      key: "ADD",
      button_name: "Add",
      Show_Button: false,
      permission: "CreatePermission",
    },
    ApproveReject: {
      key: "SETLOANLIMIT",
      button_name: "Approve/Reject loan",
      Show_Button: true,
      permission: "ActivatePermission",
    },
    dataObject: {
      objectName: "allLoanApplications",
      inputObjectName:'input',
      parameters: {
        isCompany:0,
        isRegion: 0,
        isBranch: 0,
        isFieldOfficer: 1,
      },
      ignoreFields: [
        "LoanDisbursed",
        "Installments",
        "InstallmentAmount",
        "IsLoanApproved",
        "IsBranchApproved",
        "AverageCashSales",
        "FoFirstName",
        "FoLastName",
      ],
    },
    showStatus: true,
  };

  return (
    <Box m="20px">
      <DynamicTableForJson
        title="Field Officer Appraise Loans"
        subtitle="Loan Appraisal"
        base_url={base_url}
        columns={columns}
        actions={actions}
      />
    </Box>
  );
};

export default ROLoanAppraisal;
